export const characterMapping: { [key: string]: string } = {
    // Accented characters
    'á': 'a',
    'à': 'a',
    'â': 'a',
    'ä': 'a',
    'å': 'a',
    'ã': 'a',
    'ç': 'c',
    'é': 'e',
    'è': 'e',
    'ê': 'e',
    'ë': 'e',
    'í': 'i',
    'ì': 'i',
    'î': 'i',
    'ï': 'i',
    'ñ': 'n',
    'ó': 'o',
    'ò': 'o',
    'ô': 'o',
    'ö': 'o',
    'ø': 'o',
    'õ': 'o',
    'ú': 'u',
    'ù': 'u',
    'û': 'u',
    'ü': 'u',
    'Ü': 'U',
    'ÿ': 'y',
    'ý': 'y',
    'þ': 'th',
    'æ': 'ae',
    'œ': 'oe',

    // Cyrillic characters
    'а': 'a',
    'б': 'b',
    'в': 'v',
    'г': 'g',
    'д': 'd',
    'е': 'e',
    'ё': 'e',
    'ж': 'zh',
    'з': 'z',
    'и': 'i',
    'й': 'y',
    'к': 'k',
    'л': 'l',
    'м': 'm',
    'н': 'n',
    'о': 'o',
    'п': 'p',
    'р': 'r',
    'с': 's',
    'т': 't',
    'у': 'u',
    'ф': 'f',
    'х': 'h',
    'ц': 'ts',
    'ч': 'ch',
    'ш': 'sh',
    'щ': 'sch',
    'ъ': 'y',
    'ы': 'i',
    'ь': '',
    'э': 'e',
    'ю': 'yu',
    'я': 'ya',
    'ў': 'u',
    'ћ': 'c',
    'ђ': 'dj',
    'њ': 'nj',
    'џ': 'dz',
    'є': 'e',
    'і': 'i',
    'ї': 'yi',

    // Greek characters
    'α': 'a',
    'β': 'b',
    'γ': 'g',
    'δ': 'd',
    'ε': 'e',
    'ζ': 'z',
    'η': 'i',
    'θ': 'th',
    'ι': 'i',
    'κ': 'k',
    'λ': 'l',
    'μ': 'm',
    'ν': 'n',
    'ξ': 'ks',
    'ο': 'o',
    'π': 'p',
    'ρ': 'r',
    'σ': 's',
    'τ': 't',
    'υ': 'y',
    'φ': 'ph',
    'χ': 'ch',
    'ψ': 'ps',
    'ω': 'o',
    'ά': 'a',
    'έ': 'e',
    'ί': 'i',
    'ό': 'o',
    'ύ': 'y',
    'ή': 'i',
    'ώ': 'o',
    'ς': 's',
    'ϊ': 'i',
    'ΰ': 'y',
    'ϋ': 'y',

    // German characters
    'ß': 'ss',
    'ő': 'o',
    'ű': 'u',
    'ǜ': 'u',

    // Japanese characters (Hiragana/Katakana)
    'あ': 'a',
    'い': 'i',
    'う': 'u',
    'え': 'e',
    'お': 'o',
    'か': 'ka',
    'き': 'ki',
    'く': 'ku',
    'け': 'ke',
    'こ': 'ko',
    'さ': 'sa',
    'し': 'shi',
    'す': 'su',
    'せ': 'se',
    'そ': 'so',
    'た': 'ta',
    'ち': 'chi',
    'つ': 'tsu',
    'て': 'te',
    'と': 'to',
    'な': 'na',
    'に': 'ni',
    'ぬ': 'nu',
    'ね': 'ne',
    'の': 'no',
    'は': 'ha',
    'ひ': 'hi',
    'ふ': 'fu',
    'へ': 'he',
    'ほ': 'ho',
    'ま': 'ma',
    'み': 'mi',
    'む': 'mu',
    'め': 'me',
    'も': 'mo',
    'や': 'ya',
    'ゆ': 'yu',
    'よ': 'yo',
    'ら': 'ra',
    'り': 'ri',
    'る': 'ru',
    'れ': 're',
    'ろ': 'ro',
    'わ': 'wa',
    'を': 'wo',
    'ん': 'n',

    // Korean characters (Hangul)
    '가': 'ga',
    '나': 'na',
    '다': 'da',
    '라': 'ra',
    '마': 'ma',
    '바': 'ba',
    '사': 'sa',
    '아': 'a',
    '자': 'ja',
    '차': 'cha',
    '카': 'ka',
    '타': 'ta',
    '파': 'pa',
    '하': 'ha',

    // Chinese characters (Mandarin Pinyin)
    'ā': 'a',
    'ǎ': 'a',
    'ē': 'e',
    'ě': 'e',
    'ī': 'i',
    'ǐ': 'i',
    'ō': 'o',
    'ǒ': 'o',
    'ū': 'u',
    'ǔ': 'u',
    'ǖ': 'u',
    'ǘ': 'u',
    'ǚ': 'u',

    // Hindi characters (Devanagari)
    'अ': 'a',
    'आ': 'aa',
    'इ': 'i',
    'ई': 'ii',
    'उ': 'u',
    'ऊ': 'uu',
    'ऋ': 'ri',
    'ॠ': 'rii',
    'ऌ': 'li',
    'ॡ': 'lii',
    'ए': 'e',
    'ऐ': 'ai',
    'ओ': 'o',
    'औ': 'au',
    'अं': 'am',
    'अः': 'ah',

    // Thai characters
    'ก': 'k',
    'ข': 'kh',
    'ฃ': 'kh',
    'ค': 'k',
    'ฅ': 'kh',
    'ฆ': 'kh',
    'ง': 'ng',
    'จ': 'ch',
    'ฉ': 'ch',
    'ช': 'ch',
    'ซ': 's',
    'ฌ': 'ch',
    'ญ': 'y',
    'ฎ': 'd',
    'ฏ': 't',
    'ฐ': 'th',
    'ฑ': 'th',
    'ฒ': 'th',
    'ณ': 'n',
    'ด': 'd',
    'ต': 't',
    'ถ': 'th',
    'ท': 'th',
    'ธ': 'th',
    'น': 'n',
    'บ': 'b',
    'ป': 'p',
    'ผ': 'ph',
    'ฝ': 'f',
    'พ': 'ph',
    'ฟ': 'f',
    'ภ': 'ph',
    'ม': 'm',
    'ย': 'y',
    'ร': 'r',
    'ฤ': 'rue',
    'ล': 'l',
    'ฦ': 'lue',
    'ว': 'w',
    'ศ': 's',
    'ษ': 's',
    'ส': 's',
    'ห': 'h',
    'ฬ': 'l',
    'อ': 'o',
    'ฮ': 'h',

    // Hebrew characters
    'א': 'a',
    'ב': 'b',
    'ג': 'g',
    'ד': 'd',
    'ה': 'h',
    'ו': 'v',
    'ז': 'z',
    'ח': 'kh',
    'ט': 't',
    'י': 'y',
    'ך': 'kh',
    'כ': 'kh',
    'ל': 'l',
    'ם': 'm',
    'מ': 'm',
    'ן': 'n',
    'נ': 'n',
    'ס': 's',
    'ע': 'a',
    'ף': 'f',
    'פ': 'f',
    'ץ': 'ts',
    'צ': 'ts',
    'ק': 'k',
    'ר': 'r',
    'ש': 'sh',
    'ת': 't',
    'װ': 'v',
    'ױ': 'oy',
    'ײ': 'ey',
    '׳': "'", // Hebrew apostrophe

    // Latin Extended-A
    'Ā': 'A',
    'Ă': 'A',
    'ă': 'a',
    'Ą': 'A',
    'ą': 'a',
    'Ć': 'C',
    'ć': 'c',
    'Ĉ': 'C',
    'ĉ': 'c',
    'Ċ': 'C',
    'ċ': 'c',
    'Č': 'C',
    'č': 'c',
    'Ď': 'D',
    'ď': 'd',
    'Đ': 'D',
    'đ': 'd',
    'Ē': 'E',
    'Ĕ': 'E',
    'ĕ': 'e',
    'Ė': 'E',
    'ė': 'e',
    'Ę': 'E',
    'ę': 'e',
    'Ě': 'E',
    'Ĝ': 'G',
    'ĝ': 'g',
    'Ğ': 'G',
    'ğ': 'g',
    'Ġ': 'G',
    'ġ': 'g',
    'Ģ': 'G',
    'ģ': 'g',
    'Ĥ': 'H',
    'ĥ': 'h',
    'Ħ': 'H',
    'ħ': 'h',
    'Ĩ': 'I',
    'ĩ': 'i',
    'Ī': 'I',
    'Ĭ': 'I',
    'ĭ': 'i',
    'Į': 'I',
    'į': 'i',
    'İ': 'I',
    'ı': 'i',
    'Ĳ': 'IJ',
    'ĳ': 'ij',
    'Ĵ': 'J',
    'ĵ': 'j',
    'Ķ': 'K',
    'ķ': 'k',
    'ĸ': 'k',
    'Ĺ': 'L',
    'ĺ': 'l',
    'Ļ': 'L',
    'ļ': 'l',
    'Ľ': 'L',
    'ľ': 'l',
    'Ŀ': 'L',
    'ŀ': 'l',
    'Ł': 'L',
    'ł': 'l',
    'Ń': 'N',
    'ń': 'n',
    'Ņ': 'N',
    'ņ': 'n',
    'Ň': 'N',
    'ň': 'n',
    'ŉ': 'n',
    'Ŋ': 'N',
    'ŋ': 'n',
    'Ō': 'O',
    'Ŏ': 'O',
    'ŏ': 'o',
    'Ő': 'O',
    'Œ': 'OE',
    'Ŕ': 'R',
    'ŕ': 'r',
    'Ŗ': 'R',
    'ŗ': 'r',
    'Ř': 'R',
    'ř': 'r',
    'Ś': 'S',
    'ś': 's',
    'Ŝ': 'S',
    'ŝ': 's',
    'Ş': 'S',
    'Ç': 'C',
    'ş': 's',
    'Š': 'S',
    'š': 's',
    'Ţ': 'T',
    'ţ': 't',
    'Ť': 'T',
    'ť': 't',
    'Ŧ': 'T',
    'ŧ': 't',
    'Ũ': 'U',
    'ũ': 'u',
    'Ū': 'U',
    'Ŭ': 'U',
    'ŭ': 'u',
    'Ů': 'U',
    'ů': 'u',
    'Ű': 'U',
    'Ų': 'U',
    'ų': 'u',
    'Ŵ': 'W',
    'ŵ': 'w',
    'Ŷ': 'Y',
    'ŷ': 'y',
    'Ÿ': 'Y',
    'Ź': 'Z',
    'ź': 'z',
    'Ż': 'Z',
    'ż': 'z',
    'Ž': 'Z',
    'ž': 'z',
    'ſ': 's',

    // Vietnamese characters (Diacritics)
    'Ạ': 'A',
    'ạ': 'a',
    'Ả': 'A',
    'ả': 'a',
    'Ầ': 'A',
    'ầ': 'a',
    'Ấ': 'A',
    'ấ': 'a',
    'Ậ': 'A',
    'ậ': 'a',
    'Ẩ': 'A',
    'ẩ': 'a',
    'Ẫ': 'A',
    'ẫ': 'a',
    'Ằ': 'A',
    'ằ': 'a',
    'Ắ': 'A',
    'ắ': 'a',
    'Ặ': 'A',
    'ặ': 'a',
    'Ẳ': 'A',
    'ẳ': 'a',
    'Ẵ': 'A',
    'ẵ': 'a',
    'Ẹ': 'E',
    'ẹ': 'e',
    'Ẻ': 'E',
    'ẻ': 'e',
    'Ẽ': 'E',
    'ẽ': 'e',
    'Ề': 'E',
    'ề': 'e',
    'Ế': 'E',
    'ế': 'e',
    'Ệ': 'E',
    'ệ': 'e',
    'Ể': 'E',
    'ể': 'e',
    'Ễ': 'E',
    'ễ': 'e',
    'Ị': 'I',
    'ị': 'i',
    'Ỉ': 'I',
    'ỉ': 'i',
    'Ọ': 'O',
    'ọ': 'o',
    'Ỏ': 'O',
    'ỏ': 'o',
    'Ồ': 'O',
    'ồ': 'o',
    'Ố': 'O',
    'ố': 'o',
    'Ộ': 'O',
    'ộ': 'o',
    'Ổ': 'O',
    'ổ': 'o',
    'Ỗ': 'O',
    'ỗ': 'o',
    'Ờ': 'O',
    'ờ': 'o',
    'Ớ': 'O',
    'ớ': 'o',
    'Ợ': 'O',
    'ợ': 'o',
    'Ở': 'O',
    'ở': 'o',
    'Ỡ': 'O',
    'ỡ': 'o',
    'Ụ': 'U',
    'ụ': 'u',
    'Ủ': 'U',
    'ủ': 'u',
    'Ừ': 'U',
    'ừ': 'u',
    'Ứ': 'U',
    'ứ': 'u',
    'Ự': 'U',
    'ự': 'u',
    'Ử': 'U',
    'ử': 'u',
    'Ữ': 'U',
    'ữ': 'u',
    'Ỳ': 'Y',
    'ỳ': 'y',
    'Ỵ': 'Y',
    'ỵ': 'y',
    'Ỷ': 'Y',
    'ỷ': 'y',
    'Ỹ': 'Y',
    'ỹ': 'y',

    // Georgian characters
    'ა': 'a',
    'ბ': 'b',
    'გ': 'g',
    'დ': 'd',
    'ე': 'e',
    'ვ': 'v',
    'ზ': 'z',
    'თ': 't',
    'ი': 'i',
    'კ': 'k',
    'ლ': 'l',
    'მ': 'm',
    'ნ': 'n',
    'ო': 'o',
    'პ': 'p',
    'ჟ': 'zh',
    'რ': 'r',
    'ს': 's',
    'ტ': 't',
    'უ': 'u',
    'ფ': 'p',
    'ქ': 'k',
    'ღ': 'gh',
    'ყ': 'q',
    'შ': 'sh',
    'ჩ': 'ch',
    'ც': 'ts',
    'ძ': 'dz',
    'წ': 'ts',
    'ჭ': 'ch',
    'ხ': 'kh',
    'ჯ': 'j',
    'ჰ': 'h',

    // Latin Extended-B
    'Ɓ': 'B',
    'ɓ': 'b',
    'Ƈ': 'C',
    'ƈ': 'c',
    'Ɗ': 'D',
    'ɗ': 'd',
    'Ƒ': 'F',
    'ƒ': 'f',
    'Ɠ': 'G',
    'ɠ': 'g',
    'Ƙ': 'K',
    'ƙ': 'k',
    'Ɲ': 'N',
    'ɲ': 'n',
    'Ƥ': 'P',
    'ƥ': 'p',
    'Ƭ': 'T',
    'ƭ': 't',
    'Ʋ': 'V',
    'ʋ': 'v',
    'Ƴ': 'Y',
    'ƴ': 'y',
    'Ƶ': 'Z',
    'ƶ': 'z',

    // Latin Extended-C
    'Ȧ': 'A',
    'ȧ': 'a',
    'Ȩ': 'E',
    'ȩ': 'e',
    'Ȯ': 'O',
    'ȯ': 'o',
    'Ȳ': 'Y',
    'ȳ': 'y',
    'Ⱥ': 'A',
    'ⱥ': 'a',
    'Ȼ': 'C',
    'ȼ': 'c',
    'Ƚ': 'L',
    'ƚ': 'l',
    'Ⱦ': 'T',
    'ⱦ': 't',
    'Ƀ': 'B',
    'ƀ': 'b',
    'Ǟ': 'A',
    'ǟ': 'a',
    'Ǧ': 'G',
    'ǧ': 'g',
    'Ǩ': 'K',
    'ǩ': 'k',
    'Ǫ': 'O',
    'ǫ': 'o',
    'Ǭ': 'O',
    'ǭ': 'o',
    'Ǯ': 'Ʒ',
    'ǯ': 'ʒ',
    'ǰ': 'j',
    'Ǳ': 'DZ',
    'ǲ': 'Dz',
    'ǳ': 'dz',
    'Ǵ': 'G',
    'ǵ': 'g',
    'Ǹ': 'N',
    'ǹ': 'n',
    'Ǻ': 'A',
    'ǻ': 'a',
    'Ǿ': 'O',
    'ǿ': 'o',
    'Ȝ': 'Yogh',
    'ȝ': 'yogh',

    // Latin Extended-D
    'Ȣ': 'OU',
    'ȣ': 'ou',
    'Ȥ': 'Z',
    'ȥ': 'z',

    'Ƞ': 'N',
    'ƞ': 'n',

    // Latin Extended-B (Continued)


    // Latin Extended-C (Continued)

    'ⱨ': 'H',
    'Ⱪ': 'K',
    'ⱪ': 'k',
    'Ⱬ': 'Z',
    'ⱬ': 'z',
    'Ɑ': 'A',
    'Ɒ': 'a',
    'Ⱳ': 'W',
    'ⱳ': 'w',
    'ⱴ': 'v',
    'ⱶ': 'A',
    'ⱷ': 'a',
    'ⱸ': 'E',
    'ⱹ': 'e',
    'ⱺ': 'O',
    'ⱻ': 'e',
    'ⱼ': 'j',
    'Ȿ': 'S',
    'Ɀ': 'z',
    'Ȁ': 'A',
    'ȁ': 'a',
    'Ȃ': 'A',
    'ȃ': 'a',
    'Ȅ': 'E',
    'ȅ': 'e',
    'Ȇ': 'E',
    'ȇ': 'e',
    'Ȉ': 'I',
    'ȉ': 'i',
    'Ȋ': 'I',
    'ȋ': 'i',
    'Ȍ': 'O',
    'ȍ': 'o',
    'Ȏ': 'O',
    'ȏ': 'o',
    'Ȑ': 'R',
    'ȑ': 'r',
    'Ȓ': 'R',
    'ȓ': 'r',
    'Ȕ': 'U',
    'ȕ': 'u',
    'Ȗ': 'U',
    'ȗ': 'u',
    'Ș': 'S',
    'ș': 's',
    'Ț': 'T',
    'ț': 't',
    'Ȟ': 'H',
    'ȟ': 'h',

    'ȡ': 'd',



    'ȿ': 's',
    'ɀ': 'z',
    'Ɂ': 'G',
    'ɂ': 'g',
    'Ʉ': 'U',
    'Ʌ': 'V',
    'Ɇ': 'E',
    'ɇ': 'e',
    'Ɉ': 'J',
    'ɉ': 'j',
    'Ɋ': 'Q',
    'ɋ': 'q',
    'Ɍ': 'R',
    'ɍ': 'r',
    'Ɏ': 'Y',
    'ɏ': 'y',
    'ɐ': 'a',
    'ɑ': 'a',
    'ɒ': 'a',

    'ɔ': 'o',
    'ɕ': 'c',
    'ɖ': 'd',

    'ɘ': 'e',
    'ə': 'e',
    'ɚ': 'e',
    'ɛ': 'e',
    'ɜ': 'e',
    'ɝ': 'e',
    'ɞ': 'e',
    'ɟ': 'j',

    'ɡ': 'g',
    'ɢ': 'g',
    'ɣ': 'g',
    'ɤ': 'G',
    'ɥ': 'h',
    'ɦ': 'h',
    'ɧ': 'h',
    'ɨ': 'i',
    'ɩ': 'i',
    'ɪ': 'I',
    'ɫ': 'l',
    'ɬ': 'l',
    'ɭ': 'l',
    'ɮ': 'l',
    'ɯ': 'm',
    'ɰ': 'm',
    'ɱ': 'm',

    'ɳ': 'n',
    'ɴ': 'N',
    'ɵ': 'o',
    'ɶ': 'OE',
    'ɷ': 'o',
    'ɸ': 'F',
    'ɹ': 'r',
    'ɺ': 'r',
    'ɻ': 'r',
    'ɼ': 'r',
    'ɽ': 'r',
    'ɾ': 'r',
    'ɿ': 'r',
    'ʀ': 'R',
    'ʁ': 'R',
    'ʂ': 's',
    'ʃ': 's',
    'ʄ': 'j',
    'ʅ': 's',
    'ʆ': 's',
    'ʇ': 't',
    'ʈ': 't',
    'ʉ': 'u',
    'ʊ': 'U',

    'ʌ': 'v',
    'ʍ': 'w',
    'ʎ': 'y',
    'ʏ': 'Y',
    'ʐ': 'z',
    'ʑ': 'z',
    'ʒ': 'Z',
    'ʓ': 'Z',
    'ʔ': 'G',
    'ʕ': 'E',
    'ʖ': 'E',
    'ʗ': 'c',
    'ʘ': 'O',
    'ʙ': 'B',
    'ʚ': 'e',
    'ʛ': 'g',
    'ʜ': 'H',
    'ʝ': 'j',
    'ʞ': 'k',
    'ʟ': 'L',
    'ʠ': 'q',
    'ʡ': 'q',
    'ʢ': 'q',
    'ʣ': 'dz',
    'ʤ': 'dz',
    'ʥ': 'dz',
    'ʦ': 'ts',
    'ʧ': 'ts',
    'ʨ': 'tc',
    'ʩ': 'fn',
    'ʪ': 'ls',
    'ʫ': 'lz',
    'ʬ': 'w',
    'ʭ': 'j',
    'ʮ': 'j',
    'ʯ': 'j',
    'ʰ': 'h',
    'ʱ': 'h',
    'ʲ': 'j',
    'ʳ': 'r',
    'ʴ': 'r',
    'ʵ': 'r',
    'ʶ': 'r',
    'ʷ': 'w',
    'ʸ': 'y',
    'ʹ': 'j',
    'ʺ': 'j',
    'ʻ': 'j',
    'ʼ': 'j',
    'ʽ': 'j',
    'ʾ': 'j',
    'ʿ': 'j',
    'ˀ': 'j',
    'ˁ': 'j',
    '˂': 'c',
    '˃': 'c',
    '˄': 'W',
    '˅': 'W',
    'ˆ': 'w',
    'ˇ': 'w',
    'ˈ': 'j',
    'ˉ': 'j',
    'ˊ': 'j',
    'ˋ': 'j',
    'ˌ': 'j',
    'ˍ': 'j',
    'ˎ': 'j',
    'ˏ': 'j',
    'ː': 'j',
    'ˑ': 'j',
    '˒': 'j',
    '˓': 'j',
    '˔': 'j',
    '˕': 'j',
    '˖': 'j',
    '˗': 'j',
    '˘': 'a',
    '˙': 'a',
    '˚': 'o',
    '˛': 'o',
    '˜': 'e',
    '˝': 'e',
    '˞': 'j',
    '˟': 'j',
    'ˠ': 'j',
    'ˡ': 'l',
    'ˢ': 'j',
    'ˣ': 'j',
    'ˤ': 'q',
    '˥': 'j',
    '˦': 'j',
    '˧': 'j',
    '˨': 'j',
    '˩': 'j',
    '˪': 'j',
    '˫': 'j',
    'ˬ': 'j',
    '˭': 'j',
    'ˮ': 'j',
    '˯': 'j',
    '˰': 'j',
    '˱': 'j',
    '˲': 'j',
    '˳': 'j',
    '˴': 'j',
    '˵': 'j',
    '˶': 'j',
    '˷': 'j',
    '˸': 'j',
    '˹': 'j',
    '˺': 'j',
    '˻': 'j',
    '˼': 'j',
    '˽': 'j',
    '˾': 'j',
    '˿': 'j',


    // Uppercase versions
    'Á': 'A',
    'À': 'A',
    'Â': 'A',
    'Ä': 'A',
    'Å': 'A',
    'Ã': 'A',
    'É': 'E',
    'È': 'E',
    'Ê': 'E',
    'Ë': 'E',
    'Í': 'I',
    'Ì': 'I',
    'Î': 'I',
    'Ï': 'I',
    'Ñ': 'N',
    'Ó': 'O',
    'Ò': 'O',
    'Ô': 'O',
    'Ö': 'O',
    'Ø': 'O',
    'Õ': 'O',
    'Ú': 'U',
    'Ù': 'U',
    'Û': 'U',
    'Ý': 'Y',
    'Þ': 'TH',
    'Æ': 'AE',
};